import { useOrganizations } from '@/hooks/useOrganizations';
import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

interface OrganizationProviderProps {
  children: React.ReactNode;
}

export function OrganizationProvider({ children }: OrganizationProviderProps) {
  const { selectedOrganization, isLoading, error } = useOrganizations();
  const isInitialLoadRef = useRef(true);

  // Show toast only when organization changes manually (not on initial load)
  useEffect(() => {
    if (selectedOrganization && !isLoading) {
      // Only show toast if it's not the initial load
      if (!isInitialLoadRef.current) {
        toast.success('Organization Context Changed', {
          description: `You are now working in ${selectedOrganization.name}`,
        });
      } else {
        // Mark initial load as complete
        isInitialLoadRef.current = false;
      }
    }
  }, [selectedOrganization?.id, isLoading]);

  // Show error toast if organizations fail to load
  useEffect(() => {
    if (error) {
      toast.error('Failed to load organizations', {
        description: 'Please try again later',
      });
    }
  }, [error]);

  return <>{children}</>;
}
